export enum ISearchedType {
  google,
  stop,
  location
}
